import { render, staticRenderFns } from "./cModalDevNew.vue?vue&type=template&id=70296bec&scoped=true"
import script from "./cModalDevNew.vue?vue&type=script&lang=js"
export * from "./cModalDevNew.vue?vue&type=script&lang=js"
import style0 from "./cModalDevNew.vue?vue&type=style&index=0&id=70296bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70296bec",
  null
  
)

export default component.exports